import { useStyle } from "../style";
import { SvgIcon } from "@mui/material";
import usageIconImg from "@static/img/dashboard/usage.svg";

export const UsageIcon = () => {
    const { classes } = useStyle({});

    return <SvgIcon className={classes.iconBox} component={usageIconImg} viewBox="0 0 30 30" />;
};
